import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { initializeFirestore } from 'firebase/firestore';

// Fill these in with your Firebase project's config values.
// Get them from: Firebase Console > Project Settings > General > Your apps > SDK setup and configuration
// You can hardcode them here, or set them via a .env.local file using the
// REACT_APP_FIREBASE_* variables (see .env.example).
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'YOUR_API_KEY',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'YOUR_PROJECT_ID.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'YOUR_PROJECT_ID',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'YOUR_PROJECT_ID.appspot.com',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || 'YOUR_MESSAGING_SENDER_ID',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || 'YOUR_APP_ID',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

// App Check stops anything but this app's own client from writing to
// Firestore. Get a reCAPTCHA v3 site key from Firebase Console > App Check >
// Apps > register this web app, then set REACT_APP_RECAPTCHA_SITE_KEY.
// In development, register a debug token under App Check > Apps > Manage
// debug tokens, then set REACT_APP_APPCHECK_DEBUG_TOKEN to that same value
// so `npm start` keeps working without solving a captcha every time.
if (process.env.REACT_APP_RECAPTCHA_SITE_KEY) {
  if (process.env.NODE_ENV === 'development') {
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.REACT_APP_APPCHECK_DEBUG_TOKEN || true;
  }
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(process.env.REACT_APP_RECAPTCHA_SITE_KEY),
    isTokenAutoRefreshEnabled: true,
  });
}

// Force long-polling instead of fetch-based streams. The fetch-stream
// transport throws spurious "user aborted a request" errors whenever a
// listener unmounts mid-request, which React's dev-mode overlay reports as
// an uncaught runtime error even though nothing is actually broken.
export const db = initializeFirestore(app, { useFetchStreams: false });
export default app;
